import React from 'react'
import { Modal } from 'antd'
import UserContent from './UserContent'

const AdminUserModal = ({ showModal, setShowModal, selectedData }) => {
	return (
		<Modal
			open={showModal}
			onOk={() => {
				setShowModal(false)
			}}
			onCancel={() => {
				setShowModal(false)
			}}
			zIndex={999}
			closable={false}
			footer={null}
			width={'93%'}
			style={{ top: 60 }}>
			<UserContent selectedData={selectedData} showOpen={showModal} />
		</Modal>
	)
}

export default React.memo(AdminUserModal)
